<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section class="section-shaped my-0">
        <bubbles-background></bubbles-background>
        <div class="container container-lg shape-container pb-4">
          <card shadow class="card-profile  mt-4 border-0" no-body>
            <vertical-ptwist-modules></vertical-ptwist-modules>

            <card-header title="Locations" :icon="{prefix:'fas', iconName: 'map-marked-alt'}" prefix="fas"
                         :text="pageText"></card-header>
            <div class="px-4 pb-3">
              <div class="row">
                <div class="col-md-4 col-sm-12">
                  <daterange-picker alternative></daterange-picker>
                </div>
                <div class="col-md-4 col-sm-12">
                  <collections-select v-model="collection" alternative
                                      label="Collection"></collections-select>
                </div>
                <div class="col-md-4 col-sm-12">
                  <language-select alternative label="Language"></language-select>
                </div>
              </div>
              <div class="mb-3 row">
                <div class="col-md-6">
                  <base-button tag="a"
                               class="mb-3 mb-sm-0"
                               type="button"
                               @click="changeMapType('clusters')"
                               :class="[ mapType === 'clusters' ? 'bg-blue text-white' : 'bg-secondary text-black-50']"
                               :icon="{ prefix: 'fas', iconName: 'sitemap'}">
                    Clusters
                  </base-button>
                  <base-button tag="a"
                               class="mb-3 mb-sm-0"
                               type="button"
                               @click="changeMapType('heatmap')"
                               :class="[ mapType === 'heatmap' ? 'bg-blue text-white' : 'bg-secondary text-black-50']"
                               :icon="{ prefix: 'fas', iconName: 'fire'}">
                    Heatmap
                  </base-button>

                </div>
                <div class="col-md-6 d-flex justify-content-end" v-if="mapCoordinates">
                  <div class="text-center"
                       v-show="mapCoordinates.length > 1"
                  >
                    <base-button
                      @click="mapSelection ? requestBoundingBox() : toggleAreaSelection()"
                      :outline="!mapSelection" type="success"
                      :icon="mapSelection ? { prefix: 'fas', iconName: 'check'}: null">

                      <span v-if="!mapSelection">Enable map selection</span>
                      <span v-else>Confirm selection</span>
                    </base-button>
                    <base-button v-if="mapSelection"
                                 tag="a"
                                 class="mb-3 mb-sm-0 text-white"
                                 type="danger"
                                 @click="toggleAreaSelection('heatmap')"
                                 :icon="{ prefix: 'fas', iconName: 'times'}">
                      Cancel
                    </base-button>
                  </div>
                </div>
                <modal :show.sync="showModal">
                  <template slot="header">
                    <h5 class="modal-title" id="exampleModalLabel">Selected area wordcloud
                    </h5>
                  </template>
                  <div>
                    <base-progress v-if="wordcloudProgress" type="primary"
                                   :value="progress"
                                   label="Generating Wordcloud"></base-progress>

                    <base-button
                      v-if="!wordcloudProgress"
                      tag="a"
                      class="mb-3 mb-sm-0"
                      type="button"
                      @click="changeWordcloudType('terms')"
                      :class="[ wordcloudType === 'terms' ? 'bg-blue text-white' : 'bg-secondary text-black-50']"
                      :icon="{ prefix: 'fas', iconName: 'language'}">
                      Terms
                    </base-button>
                    <base-button
                      v-if="!wordcloudProgress"
                      tag="a"
                      class="mb-3 mb-sm-0"
                      type="button"
                      @click="changeWordcloudType('hashtags')"
                      :class="[ wordcloudType === 'hashtags' ? 'bg-blue text-white' : 'bg-secondary text-black-50']"
                      :icon="{ prefix: 'fas', iconName: 'hashtag'}">
                      Hashtags
                    </base-button>

                    <vue-word-cloud
                      v-if="words"
                      class="wordcloud"
                      v-on:update:progress="wordcloudProgress = $event"
                      :words="wordcloudType === 'terms' ? words.terms : words.hashtags"
                      :color="color"
                      font-family="Roboto">
                      >
                    </vue-word-cloud>
                    <no-data-error v-else></no-data-error>
                  </div>
                  <template slot="footer">
                    <base-button type="primary" @click="showModal = false">ΟΚ</base-button>
                  </template>
                </modal>
              </div>
              <leaflet-map ref="map" :coordinates="mapCoordinates"
                           v-if="!loading"
                           :mapType="mapType"></leaflet-map>

              <ptwist-loading v-else-if="loading"></ptwist-loading>
              <server-error v-else-if="error"></server-error>
            </div>
          </card>
        </div>
      </section>
      <!-- 1st Hero Variation -->
    </div>
  </div>
</template>

<script>

import { Bus } from '../bus'
import BTooltip from 'bootstrap-vue/es/directives/tooltip/tooltip'
import { getInfoText } from '../info'
import { convertRange, getRandomArrayIndex } from '../utils'
import VerticalPtwistModules from '@/components/VerticalPtwistModules.vue'

export default {
  name: 'locations',
  directives: {
    BTooltip
  },
  components: { VerticalPtwistModules },
  data () {
    return {
      collection: 'plastic_pollution',
      language: 'en',
      loading: false,
      error: false,
      mapType: 'clusters',
      pageText: getInfoText('locations'),
      timestampFrom: null,
      timestampTo: null,
      mapSelection: false,
      mapCoordinates: [],
      showModal: false,
      words: null,
      wordcloudType: 'terms',
      wordcloudProgress: { completedWords: 0, totalWords: 200 }

    }
  },
  computed: {
    progress: function () {
      return parseInt(convertRange(this.wordcloudProgress.completedWords, [0, 200], [0, 100]))
    },
    color: function () {
      const colors = ['#179e81', '#ffc107', '#114B5F', '#88D498', '#C6DABF']
      return function () {
        return getRandomArrayIndex(colors)
      }
    }
  },
  methods: {
    changeWordcloudType (type) {
      this.wordcloudType = type
    },
    changeMapType (mapType) {
      this.mapType = mapType
    },
    requestBoundingBox () {
      let bbox = this.$refs.map.getBBox()
      this.mapSelection = false
      let payload = {
        data: {
          collection: this.collection,
          language: this.language,
          timestamp_from: this.timestampFrom,
          timestamp_to: this.timestampTo,
          bounding_box: bbox.toBBoxString()
        },
        endpoint: 'twitter/locations/wordclouds'
      }
      this.$store
        .dispatch('api/get', payload)
        .then(response => {
          this.words = this.scaleWords(response.data)
          this.showModal = true
        })
    },
    scaleWords (words) {
      if (words.terms.length > 1) {
        const termsMax = words.terms[0]
        const termsMin = words.terms[words.terms.length - 1][1]
        words.terms = words.terms.map(term => {
          return [term[0], convertRange(term[1], [termsMin, termsMax], [2, 20])]
        })
      }
      if (words.hashtags.length > 1) {
        const hashtagsMax = words.hashtags[0][1]
        const hashtagsMin = words.hashtags[words.hashtags.length - 1][1]
        words.hashtags = words.hashtags.map(term => {
          return [term[0], convertRange(term[1], [hashtagsMin, hashtagsMax], [2, 20])]
        })
      }
      return words
    },
    updateMap () {
      this.mapSelection = false
      this.loading = true
      let payload = {
        data: {
          collection: this.collection,
          language: this.language,
          timestamp_from: this.timestampFrom,
          timestamp_to: this.timestampTo
        },
        endpoint: 'twitter/locations'
      }
      this.$store
        .dispatch('api/get', payload)
        .then(response => {
          this.mapCoordinates = response.data
        })
        .catch(error => {
          console.error(error)
          this.error = true
        })
        .finally(() => {
          this.loading = false
        })
    },
    toggleAreaSelection () {
      if (this.mapSelection) {
        this.mapSelection = false
        Bus.$emit('disable-area-select', this.language)
      } else {
        this.mapSelection = true
        Bus.$emit('enable-area-select', this.language)
      }
    }
  },
  watch: {
    timestampFrom () {
      this.updateMap()
    },
    collection () {
      this.updateMap()
    },
    language () {
      this.updateMap()
    }
  },
  created () {
    Bus.$on('new-language', function (newLanguage) {
      this.language = newLanguage
      Bus.$emit('new-collections', this.language)
    }.bind(this))
    Bus.$on('new-collection', function (newCollection) {
      this.collection = newCollection
    }.bind(this))
    Bus.$on('daterange-update', function (timestamps) {
      this.timestampFrom = timestamps.from
      this.timestampTo = timestamps.to
    }.bind(this))
  }
}
</script>
<style lang="sass">
  .wordcloud
    width: 100%
    height: 500px !important
</style>
